import { signal } from "@angular/core";
import { createClient, Session, SupabaseClient } from "@supabase/supabase-js";
import { Database } from "../types/database.types";

// Singleton client and session signal for reuse
let clientRef: SupabaseClient<Database> | null = null;
export const supabaseSession = signal<Session | null>(null);

export function getSupabaseClient(): SupabaseClient<Database> {
  if (clientRef) return clientRef;
  const url = import.meta.env.NG_APP_SUPABASE_URL;
  const key = import.meta.env.NG_APP_SUPABASE_ANON_KEY;
  clientRef = createClient<Database>(url, key);
  // initialize session tracking once
  initSessionListeners(clientRef);
  return clientRef;
}

async function initSessionListeners(client: SupabaseClient<Database>) {
  const { data } = await client.auth.getSession();
  supabaseSession.set(data.session);
  client.auth.onAuthStateChange((_e, s) => supabaseSession.set(s));
}
